import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Text from 'components/common/Text/Text'
import AppointmantHeader from './components/AppointmantHeader'
import Appointment from './components/Appointment'
import UpdateCancelInstructionsModal from './components/UpdateCancelInstructionsModal'

const BOTMyAppointmentsDetails = ({
  hasMounted,
  title,
  appointments = [],
  isAuthorized,
  hasAppointments,
  emailDesc,
  emailTitle,
  emailType,
  placeholders: {
    appointmentOptions,
    noAccountMessage
  },
  updateCancelAppointment
}) =>
  <Wrapper centered={ !isAuthorized && !hasAppointments } data-at-myaccount-myappointments>
    {
      hasMounted &&
        <Fragment>
          {
            !isAuthorized && !hasAppointments &&
              appointmentOptions
          }
          {
            (hasAppointments || isAuthorized) &&
              <AppointmantHeader title={ title } />
          }
          {
            !isAuthorized && hasAppointments &&
              noAccountMessage
          }
        </Fragment>
    }
    {
      isAuthorized && !hasAppointments &&
        <Text>
          You currently do not have any past or upcoming appointments.
        </Text>
    }
    {
      hasAppointments &&
        appointments.map(({ quotedItemAndServices = [], vehicle }) =>
          quotedItemAndServices.map(({
            timeSlot,
            freeAligmentTooltip,
            appointmentId,
            storeAddress,
            orderId,
            isUpcomingAppointment
          }, index) =>
            <Appointment
              vehicle={ vehicle }
              timeSlot={ timeSlot }
              emailModalData={{ emailDesc, emailTitle, emailType, appointmentId }}
              store={ storeAddress }
              orderId={ orderId }
              isUpcomingAppointment={ isUpcomingAppointment }
              updateCancelAppointment={ updateCancelAppointment }
              freeAlignmentCheckSku={ freeAligmentTooltip }
              quotedItemAndServices={ quotedItemAndServices[index] }
              key={ index } />
          )
        )
    }
    <UpdateCancelInstructionsModal />
  </Wrapper>

BOTMyAppointmentsDetails.propTypes = {
  appointments: PropTypes.arrayOf(PropTypes.shape()),
  emailDesc: PropTypes.string,
  emailTitle: PropTypes.string,
  emailType: PropTypes.string,
  hasAppointments: PropTypes.bool,
  hasMounted: PropTypes.bool,
  isAuthorized: PropTypes.bool,
  placeholders: PropTypes.shape({
    appointmentOptions: PropTypes.arrayOf(),
    noAccountMessage: PropTypes.arrayOf()
  }),
  title: PropTypes.string,
  updateCancelAppointment: PropTypes.arrayOf(PropTypes.shape())
}

export default BOTMyAppointmentsDetails

const Wrapper = styled.div`
  ${Media.desktop`
    ${props => props.centered && css`
      text-align: center;
    `}
  `}
  ${Mixin.responsive('padding', '0', '0 16px')}
`
